import React, { useState } from "react"
import { Card } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import _ from "lodash"
import * as RenderProps from "./renderProps"

import {
  Settings as LoopIcon,
  FilterList as FilterListIcon,
} from "@material-ui/icons"
import { useStyles, StyledTabNumber } from "./styles"
import { useTranslation } from "react-i18next"

function GridSearchList(props) {
  const {
    title = "",
    searchGridListTriggerApi = () => "",
    mainStateDashboard = {},
  } = props || {}
  const { t } = useTranslation()
  const classes = useStyles()

  const capitalizeText = (text) => {
    return text.replace(/\b(\w)/g, (s) => s.toUpperCase())
  }
  const handleListClick = (itm) => {
    mainStateDashboard?.setTextDTitleSyncLoadTemp(itm?.title || "")
    let rowItemUpdate =
      mainStateDashboard.retailerList &&
      mainStateDashboard.retailerList.map((item) => {
        if (item.id === itm.id) {
          item.isActive = true
        } else {
          item.isActive = false
        }
        return item
      })
    const { id = "", address = "", title = "", status = "" } = itm
    const data = { tenantId: id, address, title, status }

    mainStateDashboard.setRetailerList(rowItemUpdate)
    let splitQS = mainStateDashboard.pageLocation?.search.split("&")

    mainStateDashboard?.setLocalStorageValues({ value: data })
    mainStateDashboard.pageHistory.push(
      `${mainStateDashboard.pageLocation?.pathname}${splitQS[0]}&${t('retailer')}=${itm.id}&${t('subpage')}=${mainStateDashboard.subPageIndex}`
    )
  }

  const triggerRef = React.useRef(searchGridListTriggerApi)
  React.useEffect(() => {
    triggerRef.current = searchGridListTriggerApi
  }, [searchGridListTriggerApi])

  const debouncedSearchApi = React.useRef(
    _.debounce((val) => {
      if (triggerRef.current) {
        triggerRef.current(val)
      }
    }, 600)
  ).current

  React.useEffect(() => {
    return () => {
      debouncedSearchApi.cancel()
    }
  }, [debouncedSearchApi])

  const handleSearchField = (event) => {
    const val = event.target.value?.replace(/(\s{2,})/g, " ") || ""
    mainStateDashboard.setSearchFieldValue(val)
    if (val.trim().length === 0) {
      debouncedSearchApi.cancel()
      searchGridListTriggerApi("")
    } else {
      debouncedSearchApi(val)
    }
  }

  const handleSearchBluredField = (event) => {
    const val = event.target.value?.replace(/(\s{2,})/g, " ") || ""
    mainStateDashboard.setSearchFieldValue(val)
    debouncedSearchApi.cancel()
    searchGridListTriggerApi(val)
  }

  const handleSearchIconButton = () => {
    debouncedSearchApi.cancel()
    const value = mainStateDashboard.refFieldValue.current.querySelector(
      "input"
    ).value
    mainStateDashboard.setSearchFieldValue(value)
    searchGridListTriggerApi(value)
  }

  const handleClearSearch = () => {
    debouncedSearchApi.cancel()
    mainStateDashboard.setSearchFieldValue("")
    searchGridListTriggerApi("")
  }

  const leftSideBarProps = {
    title,
    mainStateDashboard,
    handleSearchField,
    handleSearchIconButton,
    handleSearchBluredField,
    handleListClick,
    capitalizeText,
    handleClearSearch,
    t
  }

  return (
    <div>
      <Card className={classes.cardStyles}>
        {RenderProps.RetailerLeftSideBar(leftSideBarProps)}
      </Card>
    </div>
  )
}

export default GridSearchList
export { GridSearchList }
